import { useStaticQuery, graphql } from 'gatsby'

import getContentElement from 'lib/content/sanity'

/**
 * returns: {
 *  quoteElement: ReactElement,
 *  author: String, `firstName lastName`,
 *  jobTitle: String,
 *  organization: String,
 *  headshot: image object containgin gatsbyImageData
 * }
 */
export default function useSanityTestimonial ({ title, opts }) {
  const data = useStaticQuery(graphql`
    {
      allSanityTestimonial {
        nodes {
          _rawQuote(resolveReferences: { maxDepth: 10 })
          title
          quoteAuthor {
            image {
              asset {
                gatsbyImageData
              }
            }
            jobTitle
            lastName
            organization {
              organizationName
              shortenedName
            }
            firstName
          }
        }
      }
    }
  `)

  const testimonial = data?.allSanityTestimonial?.nodes.find(
    (node) => node.title === title
  )

  return {
    quoteElement: getContentElement({ content: testimonial?._rawQuote, opts }),
    author: `${testimonial?.quoteAuthor?.firstName} ${testimonial?.quoteAuthor?.lastName}`,
    jobTitle: testimonial?.quoteAuthor?.jobTitle,
    organization: testimonial?.quoteAuthor?.organization?.organizationName,
    organizationShortened:
      testimonial?.quoteAuthor?.organization?.shortenedName,
    authorHeadshot: testimonial?.quoteAuthor?.image?.asset,
  }
}
